type RoutePathRenderFunction = (...args: any) => string;

type RouteDefinition<T extends RoutePathRenderFunction> = T extends (
  ...args: infer P
) => string
  ? {
      pathDefinition: string;
      render: (...args: P) => string;
    }
  : never;

function makeStaticRouteDefinition(
  pathDefinition: string
): RouteDefinition<() => string> {
  return makeRouteDefinition(pathDefinition, () => pathDefinition);
}

function makeRouteDefinition<T extends RoutePathRenderFunction>(
  pathDefinition: string,
  render: T
): RouteDefinition<T> {
  return {
    pathDefinition,
    render,
  } as any;
}

export const CompanyScreensPath = makeRouteDefinition(
  "/:companySlug",
  (companySlug: string) => `/${companySlug}`
);

export const orderPaymentScreenPath = makeRouteDefinition(
  "/:companySlug/order",
  (
    companySlug: string,
    query: {
      token?: string | null;
    } | null = null
  ) => {
    let path = `/${companySlug}/order`;
    if (query != null) {
      const searchParams = new URLSearchParams({});
      if (query.token != null) {
        searchParams.append("token", query.token);
      }

      path = `${path}?${searchParams.toString()}`;
    }
    return path;
  }
);

export const baseRoute = makeStaticRouteDefinition("/");
